// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"7654ed27","263":"e906b1b2","283":"7d4b6fb9","374":"9362a4d6","488":"9a9d17b2","658":"e98a075b","748":"be21b4a6","752":"f8d9ab8e","809":"727b122c","872":"c1f7f3fe","875":"97a8cad3"}[chunkId] + ".chunk.js";
};